import { detectPlatform } from "./detect";
import { createWebPlatform } from "./web";

export * from "./detect";
export * from "./ports";

/**
 * The adapter for the current platform. The web adapter (a few KB over IndexedDB) is static, so it
 * downloads with the app instead of as one more request after it has started (PRD §5 cold start); the
 * Tauri adapter stays a lazy chunk, off the web's critical path.
 */
export async function createPlatform(options: { onVersionChange?: () => void } = {}) {
  if (detectPlatform() === "web") return createWebPlatform(options);
  return (await import("./tauri")).createTauriPlatform();
}
